import { c as _c } from "react/compiler-runtime";
import NumberInput from "@components/hookform/NumberInput";
import TextField from "@components/hookform/TextField";
import { formatNumber } from "@justhome/common";
import { useGetAssumptions } from "@justhome/api-core";
import { PERCENTAGE_PATTERN, POSTAL_CODE_PATTERN } from "@justhome/common/constants";
import { ErrorMessage } from "@justhome/react-ui";
import RadioCard from "@justhome/react-ui/src/RadioCard";
import useLanguage from "@lib/hooks/useLanguage";
import { no, yes, YesNo, yesNoOptions } from "@lib/options";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FormField, FormRow } from "../Form";
export interface PropertyFieldsValues {
  purchasePrice?: number;
  postalCode?: string;
  realEstateAgentFeePercentage?: string;
  hasRealEstateAgentFee?: YesNo;
}
const PropertyFields = () => {
  const $ = _c(74);
  const {
    t
  } = useBookingTranslation();
  const locale = useLanguage();
  const {
    control,
    getValues,
    setValue,
    register,
    formState: t0
  } = useFormContext();
  const {
    errors
  } = t0;
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "hasRealEstateAgentFee"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasRealEstateAgentFee = useWatch(t1);
  let t2;
  if ($[2] !== control) {
    t2 = {
      control,
      name: "postalCode"
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const postalCode = useWatch(t2);
  let t3;
  let t4;
  if ($[4] !== postalCode) {
    t3 = {
      queryParams: {
        zipCode: postalCode
      }
    };
    t4 = postalCode && POSTAL_CODE_PATTERN.test(postalCode);
    $[4] = postalCode;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  const t5 = !!t4;
  let t6;
  if ($[7] !== t5) {
    t6 = {
      enabled: t5
    };
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const {
    data: assumptions
  } = useGetAssumptions(t3, t6);
  let t7;
  let t8;
  if ($[9] !== assumptions || $[10] !== getValues || $[11] !== hasRealEstateAgentFee || $[12] !== locale || $[13] !== setValue) {
    t7 = () => {
      const currentValue = getValues("realEstateAgentFeePercentage");
      if (hasRealEstateAgentFee === no) {
        if (currentValue) {
          setValue("realEstateAgentFeePercentage", undefined);
        }
        return;
      }
      if (!currentValue && assumptions) {
        setValue("realEstateAgentFeePercentage", formatNumber(assumptions.realEstateAgentFeePercentage, true, locale));
      }
    };
    t8 = [assumptions, getValues, setValue, hasRealEstateAgentFee, locale];
    $[9] = assumptions;
    $[10] = getValues;
    $[11] = hasRealEstateAgentFee;
    $[12] = locale;
    $[13] = setValue;
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  useEffect(t7, t8);
  let t9;
  if ($[16] !== t) {
    t9 = t("propertyForm.purchasePriceLabel");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("propertyForm.purchasePricePlaceholder");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("propertyForm.purchasePriceRequiredError");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = {
      required: t11
    };
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = errors.purchasePrice?.message;
  let t14;
  if ($[24] !== control || $[25] !== t10 || $[26] !== t12 || $[27] !== t13 || $[28] !== t9) {
    t14 = <FormRow><FormField><NumberInput name="purchasePrice" label={t9} placeholder={t10} suffix={"\u20AC"} control={control} rules={t12} errorMessage={t13} /></FormField></FormRow>;
    $[24] = control;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("propertyForm.postalCodeLabel");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("propertyForm.postalCodePlaceholder");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t("propertyForm.postalCodeRequiredError");
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("propertyForm.postalCodeInvalidError");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t18) {
    t19 = {
      value: POSTAL_CODE_PATTERN,
      message: t18
    };
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t17 || $[41] !== t19) {
    t20 = {
      required: t17,
      pattern: t19
    };
    $[40] = t17;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  const t21 = errors.postalCode?.message;
  let t22;
  if ($[43] !== control || $[44] !== t15 || $[45] !== t16 || $[46] !== t20 || $[47] !== t21) {
    t22 = <FormRow><FormField><TextField name="postalCode" label={t15} placeholder={t16} control={control} inputMode="numeric" rules={t20} errorMessage={t21} /></FormField></FormRow>;
    $[43] = control;
    $[44] = t15;
    $[45] = t16;
    $[46] = t20;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t) {
    t23 = t("propertyForm.hasRealEstateAgentFeeLabel");
    $[49] = t;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t23) {
    t24 = <label htmlFor="hasRealEstateAgentFee" className="block text-title-1 mb-xs">{t23}</label>;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== register || $[54] !== t) {
    t25 = yesNoOptions.map(option => <RadioCard size="sm" key={option} value={option} type="radio" {...register("hasRealEstateAgentFee", {
      required: t("propertyForm.hasRealEstateAgentFeeRequiredError")
    })}>{t(`yesNo.${option}`)}</RadioCard>);
    $[53] = register;
    $[54] = t;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t25) {
    t26 = <div className="flex gap-3xs">{t25}</div>;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== errors.hasRealEstateAgentFee) {
    t27 = errors.hasRealEstateAgentFee && <ErrorMessage>{errors.hasRealEstateAgentFee?.message}</ErrorMessage>;
    $[58] = errors.hasRealEstateAgentFee;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t24 || $[61] !== t26 || $[62] !== t27) {
    t28 = <FormRow><FormField>{t24}{t26}{t27}</FormField></FormRow>;
    $[60] = t24;
    $[61] = t26;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== control || $[65] !== errors.realEstateAgentFeePercentage?.message || $[66] !== hasRealEstateAgentFee || $[67] !== t) {
    t29 = hasRealEstateAgentFee === yes && <FormRow><FormField><TextField name="realEstateAgentFeePercentage" label={t("propertyForm.realEstateAgentFeePercentageLabel")} placeholder={t("propertyForm.realEstateAgentFeePercentagePlaceholder")} inputMode="numeric" control={control} suffix="%" rules={{
          required: t("propertyForm.realEstateAgentFeePercentageRequiredError"),
          pattern: {
            value: PERCENTAGE_PATTERN,
            message: t("propertyForm.realEstateAgentFeePercentageInvalidError")
          }
        }} errorMessage={errors.realEstateAgentFeePercentage?.message} /></FormField></FormRow>;
    $[64] = control;
    $[65] = errors.realEstateAgentFeePercentage?.message;
    $[66] = hasRealEstateAgentFee;
    $[67] = t;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== t14 || $[70] !== t22 || $[71] !== t28 || $[72] !== t29) {
    t30 = <>{t14}{t22}{t28}{t29}</>;
    $[69] = t14;
    $[70] = t22;
    $[71] = t28;
    $[72] = t29;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  return t30;
};
export default PropertyFields;